import React from 'react';

import cx from 'classnames';
import { prop } from 'ramda';
import { Link } from 'react-scroll';

import { getOriginTitle } from 'components/Pages/Admin/Page/Landing/utils';
import Icon from 'components/shared/Icon';
import Left from 'components/shared/Icon/icons/Left';
import Visibility from 'components/shared/Icon/icons/Visibility';
import VisibilitySlash from 'components/shared/Icon/icons/VisibilitySlash';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import { getEyeTooltipMsg } from 'utils/itineraries/functions/utils';

import Wrapper from '../Wrapper';
import styles from './index.module.css';
import useItem from './useItem';

function Item(props) {
  const { isItinerariesItem, link, index, getBaseOffset, handleLinkClick } = props;
  const { hidden, empty, showEyeIcon, setShowEyeIcon, handleToggleEyeClick } = useItem({ pageIndex: index });

  const realTitle = getOriginTitle(link);
  const isEmptyItem = !realTitle;
  const linkText = isEmptyItem ? 'Section Name' : realTitle;

  const eyeIconClasses = cx(styles.eyeIcon, hidden && styles.eyeIconActive);
  const linkClasses = cx(styles.link);

  return (
    <div
      className={cx(styles.item, isEmptyItem && prop('empty', styles))}
      onMouseEnter={() => setShowEyeIcon(true)}
      onMouseLeave={() => setShowEyeIcon(false)}
    >
      <Link
        to={link}
        className={linkClasses}
        activeClass={styles.linkActive}
        containerId={LANDING_PAGES_CONTAINER_ID}
        smooth
        duration={200}
        spy
        offset={getBaseOffset()}
        ignoreCancelEvents={false}
        isDynamic
        onClick={() => handleLinkClick(link, LANDING_PAGES_CONTAINER_ID)}
      >
        <Wrapper hidden={hidden} isItinerariesItem={isItinerariesItem}>
          {linkText}
        </Wrapper>
      </Link>

      {isItinerariesItem && (showEyeIcon || hidden) && (
        <div>
          {hidden ? (
            <Icon
              component={VisibilitySlash}
              className={styles.eyeSlashIcon}
              onClick={handleToggleEyeClick}
              data-tip
              data-for={`hide_icon${index}`}
            />
          ) : (
            <Icon
              component={Visibility}
              width="20px"
              height="12px"
              className={eyeIconClasses}
              onClick={handleToggleEyeClick}
              data-tip
              data-for={`hide_icon${index}`}
            />
          )}

          <Tooltip place="top" id={`hide_icon${index}`} withMouseOver>
            <TooltipText>
              <div style={{ minWidth: 100 }}>
                <p style={{ whiteSpace: 'pre-line', textAlign: 'center', fontWeight: '500' }}>
                  {getEyeTooltipMsg({ isHidden: hidden, canBeVisible: !empty })}
                </p>
              </div>
            </TooltipText>
          </Tooltip>
        </div>
      )}
      <Icon component={Left} width="0.7rem" height="1.3rem" className={styles.linkIcon} />
    </div>
  );
}

export default React.memo(Item);
